// Registr native agend Inventory.

import type { AgendaRegistration } from '@/shared/navigation';

import {
  AirlineDetailPage,
  airlineDetailAgenda,
  AirlineListPage,
  airlineListAgenda,
} from './airlines';
import { INVENTORY_AIRLINES, INVENTORY_VEHICLES } from './permissions';
import {
  VehicleDetailPage,
  vehicleDetailAgenda,
  VehicleListPage,
  vehicleListAgenda,
} from './vehicles';

/** Agendy slice Vehicle inventory (route `/inventory-vehicles`). */
export const inventoryVehicleAgendas: AgendaRegistration[] = [
  { agenda: vehicleListAgenda, component: VehicleListPage, permission: INVENTORY_VEHICLES },
  { agenda: vehicleDetailAgenda, component: VehicleDetailPage, permission: INVENTORY_VEHICLES },
];

/** Agendy slice leteckých společností (route `/inventory-airlines`). */
export const inventoryAirlineAgendas: AgendaRegistration[] = [
  { agenda: airlineListAgenda, component: AirlineListPage, permission: INVENTORY_AIRLINES },
  { agenda: airlineDetailAgenda, component: AirlineDetailPage, permission: INVENTORY_AIRLINES },
];
